module.exports = __webpack_public_path__ + "a2007d191f50bf593d84ee691740f71b.svg";